import { h } from '@stencil/core';
import type { ObservableMap } from '@stencil/store';

import type { MatchStoreState, PlayerEvent } from '../../../../../services/interfaces';
import { isEmpty } from '../../../../../services/utils';
import { setCssVariant } from '../../helpers/match-unit.helpers';

type Props = {
  isAwayTeam?: boolean;
  state: ObservableMap<MatchStoreState>['state'];
};

const renderRedCard = (key: string): HTMLPkIconElement => (
  <pk-icon class="team-red-card" name="football-card-single-card" color="support-04A" key={key} part="red-card-icon" />
);

const TeamRedCards = ({ state, isAwayTeam = false }: Props): HTMLDivElement => {
  const cssVariant = setCssVariant(state.size);

  const match = state.matchData;
  const showRedCards = state.showRedCards;
  if (!match || !showRedCards) return null;

  const awayTeam = match.awayTeam;
  const homeTeam = match.homeTeam;
  const redCards = match.playerEvents?.redCards;

  return (
    <div
      class={{
        'pk-match__base--home-redcards': !isAwayTeam,
        'pk-match__base--away-redcards': isAwayTeam,
        ...cssVariant,
      }}
      part={!isAwayTeam ? 'home-red-cards' : 'away-red-cards'}
    >
      {!isEmpty(redCards) &&
        redCards.map((playerEvent: PlayerEvent, index: number) => {
          if (!isAwayTeam && playerEvent.teamId === homeTeam.id) {
            return renderRedCard(`red-card-${homeTeam.id}-${index}`);
          }
          if (isAwayTeam && playerEvent.teamId === awayTeam.id) {
            return renderRedCard(`red-card-${awayTeam.id}-${index}`);
          }
        })}
    </div>
  );
};

export { TeamRedCards };
